module.exports = {
  '000': 'F',
  '010': 'D',
  '011': 'C',
  '012': 'B',
  '013': 'A',
  '020': 'D',
  '030': 'D',
  '031': 'C',
  '032': 'B',
  '040': 'D',
  '100': 'F',
  '110': 'E',
  '111': 'B',
  '112': 'C',
  '113': 'A',
  '120': 'E',
  '130': 'E',
  '131': 'B',
  '132': 'C',
  '140': 'E'
}



// WEBPACK FOOTER //
// ./src/universal/spinneybeck/sp402-variant-names.js